"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import Icon from "../../graphics/Icon/Icon.js";
import Group from "../../layout/Group/Group.js";
import Link from "../../navigation/Link/Link.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import Paragraph from "../../typography/Paragraph/Paragraph.js";
import { Button } from "@mantine/core";
import { forwardRef } from "react";
import '../../../assets/AnimatedButton.css';const root = "_root_1luyd_2";
const group = "_group_1luyd_38";
const text = "_text_1luyd_42";
const icon = "_icon_1luyd_52";
const circle = "_circle_1luyd_58";
const AnimatedButtonStyles = {
  root,
  group,
  text,
  icon,
  circle
};
const _AnimatedButton = forwardRef((props, ref) => {
  const { link, variant = "dark", useParentLink, mod, ...rest } = props;
  const content = /* @__PURE__ */ jsxs(Group, { align: "center", wrap: "nowrap", spacing: "lg", className: AnimatedButtonStyles.group, children: [
    /* @__PURE__ */ jsx(Paragraph, { text: link.text, className: AnimatedButtonStyles.text }),
    /* @__PURE__ */ jsx(
      Icon,
      {
        color: variant === "light" ? "dark" : "light",
        name: "ArrowRight",
        className: AnimatedButtonStyles.icon
      }
    ),
    /* @__PURE__ */ jsx("span", { className: AnimatedButtonStyles.circle })
  ] });
  return useParentLink ? /* @__PURE__ */ jsx(
    Button,
    {
      ...rest,
      ref,
      pl: "lg",
      pr: "xs",
      classNames: AnimatedButtonStyles,
      mod: { variant, ...mod },
      children: content
    }
  ) : /* @__PURE__ */ jsx(Link, { href: link.href, target: link.target, ...rest, ref, mod, children: /* @__PURE__ */ jsx(Button, { pl: "lg", pr: "xs", classNames: AnimatedButtonStyles, mod: { variant }, children: content }) });
});
_AnimatedButton.displayName = "AnimatedButton";
const AnimatedButton = sharedHandler(_AnimatedButton);
AnimatedButton.displayName = _AnimatedButton.displayName;
export {
  AnimatedButtonStyles as A,
  AnimatedButton as default
};
